<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ title }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <p class="dialog-note">
    {{ data.instanceIds.length }} room-day(s) selected. Only fully free room-days
    (no bookings held) will change; the rest are skipped.
  </p>

  <div class="dialog-form">
    <div class="field-row">
      <div class="field">
        <span class="field-label">Reason</span>
        <input class="text-box-active" [(ngModel)]="reason" [placeholder]="data.action === 'BLOCK' ? 'Why is this blocked?' : 'Optional'" />
      </div>
    </div>
  </div>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Cancel</button>
    <button type="button" class="ac-primary-btn" (click)="submit()">{{ data.action === 'BLOCK' ? 'Block' : 'Unblock' }}</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
